import Client from "./client";

const baseUrl = `/api/1/users`;

function user() {
  return {
    getCurrentUserSummary: () => {
      return Client.get(baseUrl + "/currentUserSummary");
    },
    getCurrentUser: () => {
      return Client.get(baseUrl + "/currentUser");
    },
    getProfile: () => {
      return Client.get(baseUrl + "/profile");
    },

    updateProfile: ({ params = {}, payload }) => {
      return Client.put(baseUrl, payload);
    },

    uploadAvatar: data => {
      const url = baseUrl + "/avatar";
      return Client.post(url, data.payload, {});
    },
    getUserLimitationsInfo: () => {
      return Client.get(baseUrl + "/limitations");
    },
    activate2FA: () => {
      return Client.get(baseUrl + "/2FA/activate");
    },
    check2FAcode: totpDto => {
      const url = baseUrl + "/2FA/confirm2FA";
      return Client.putWithoutLoading(url, totpDto);
    },

    deActivate2FA: totpDto => {
      const url = baseUrl + "/2FA/deActivate";
      return Client.put(url, totpDto);
    },
    check2faEmail: user2FAActivateDto => {
      const url = baseUrl + "/2FA/verify2faEmail";
      return Client.postWithoutLoading(url, user2FAActivateDto);
    },

    validateEmailVerificationForWhitelistChange: updateDto => {
      return Client.post(baseUrl + `/setting/validate`, updateDto);
    },

    resendVerify2FAEmail: () => {
      const url = baseUrl + "/2FA/resendVerifyEmail";
      return Client.get(url);
    },

    changeUserSettings: ({ payload }) => {
      const url = baseUrl + "/setting";
      return Client.put(url, payload);
    },
    resendEmailForValidation: () => {
      const url = baseUrl + "/resend";
      return Client.put(url);
    },
    postUser: ({ payload }) => {
      const url = baseUrl + "/history";
      return Client.post(url, payload);
    },
    getUserDevices: ({ params }) => {
      const url =
        baseUrl + `/device/info/${params.pageSize}/${params.pageNumber}`;
      return Client.get(url);
    },
    getMyFavoriteCurrencies: () => {
      const url = baseUrl + `/setting/favorite/currency`;
      return Client.get(url);
    },
    postListUserNotificationSettings: ({ payload }) => {
      const url = "/api/1/notif/setting/update/list";
      return Client.put(url, payload);
    },
    getListUserNotificationSettings: () => {
      const url = "/api/1/notif/setting/self";
      return Client.get(url);
    },
    addAlert: ({ payload }) => {
      const url = "/api/1/alert";
      return Client.post(url, payload);
    },
    deleteAlertById: ({ params }) => {
      const url = `/api/1/alert/${params.id}`;
      return Client.delete(url);
    },
    deleteSomeAlert: ids => {
      const url = `/api/1/alert/delete`;
      return Client.put(url, ids);
    },
    // deleteAllAlerts: ({ params }) => {
    //   const url = `/api/1/alert/delete`;
    //   return Client.delete(url);
    // },
    getAlerts: ({ params }) => {
      const url = `/api/1/alert/self/${params.pageSize}/${params.pageNumber}`;
      return Client.get(url);
    }
  };
}

export default user();
